import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch'; 

import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class UnitService {

  constructor(
    private global: GlobalDataService,
    private http: HttpClient  
    ) { }


   getUnit(isActive:number=-1) {

    let isAvailable: string ="?active="+isActive;

    if(isActive==-1){
        isAvailable="";
    }

        return this.http.get(this.global.httpUrl+"units"+isAvailable)
             .catch((err: HttpErrorResponse) => {
             console.log("error");
               this.global.refreshToken().subscribe(response=>{ localStorage.setItem('token', response['token']);});

               return Observable.throw(err);

             }); 
    }

   getUnitById(id: any) {
        return this.http.get(this.global.httpUrl+"units/"+id);
    } 

   createUnit(data: any){
        return this.http.post(this.global.httpUrl+"units", data);
    }

   updateUnit(data: any,id: any){
        return this.http.put(this.global.httpUrl+"units/"+id, data);

    } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/units/unit.service.ts